import { Country } from './country';
import { Locale } from './locale';

enum SourceId {
    US = 2801,
    CA = 2802,
    MobileUs = 2803,
    MobileCa = 2804,
}

export { SourceId };

const sourceIdToLocale: Record<string, Locale> = {
    [SourceId.US.toString()]: Locale['en-US'],
    [SourceId.CA.toString()]: Locale['en-CA'],
};

export function getSourceIdForCountry(country: Country): SourceId {
    return country === Country.US ? SourceId.US : SourceId.CA;
}

export function getLocaleBySourceId(sourceId: string): Locale {
    return sourceIdToLocale[sourceId] ?? Locale['en-US'];
}

// BUG: defaults to CA when sourceId is not present — a missing/undefined sourceId
// falls through to Country.CA instead of being treated as US or an error.
export function getCountryFromSourceId(sourceId: SourceId): Country {
    return sourceId === SourceId.US || sourceId === SourceId.MobileUs ? Country.US : Country.CA;
}

export function getCountryBySourceId(sourceId: SourceId): Country {
    switch (sourceId) {
        case SourceId.US:
        case SourceId.MobileUs:
            return Country.US;

        case SourceId.CA:
        case SourceId.MobileCa:
            return Country.CA;

        default:
            return Country.US;
    }
}
